import { CommonModule } from '@angular/common';
import { environment } from '@environments/environment';
import { Component, Input, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { RegisterLoginComponent } from '../auth/register-login/register-login.component';
import { AuthService, UserSignal } from '@app/services/auth.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { GcImageComponent } from '../gc-image/gc-image.component';
import { UserService } from '@app/services/user.service';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MatListModule, MatNavList } from '@angular/material/list';
import { TourAnchorMatMenuDirective } from 'ngx-ui-tour-md-menu';

@Component({
  selector: 'app-user-dropdown',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
    GcImageComponent,
    RouterLink,
    MatMenuModule,
    MatNavList,
    MatListModule,
    RouterLink,
    RouterLinkActive,
    TourAnchorMatMenuDirective,
  ],
  templateUrl: './user-dropdown.component.html',
  styleUrl: './user-dropdown.component.scss',
})
export class UserDropdownComponent implements OnInit {
  advertiseUrl = environment.advertiseUrl;
  user = signal<UserSignal>(undefined);
  @Input() dropdownStyle: 'dropdown' | 'mat-nav-item' = 'dropdown';
  nestedOpen = signal(false);

  constructor(
    private dialog: MatDialog,
    public authService: AuthService,
    public userService: UserService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.user = this.authService.userSignal;

    this.userService.userPhoto.set(this.userService.getUserPhoto(this.authService?.userSignal()?.uid));
  }

  openLoginDialog() {
    this.dialog.open(RegisterLoginComponent, {
      maxWidth: '1000px',
      data: {
        type: 'login',
      },
    });
  }

  openVerifyDialog() {
    this.dialog.open(RegisterLoginComponent, {
      maxWidth: '1000px',
      data: {
        type: 'verify',
      },
    });
  }

  logout() {
    this.authService.logout().then(() => {
      // TODO: Fix the issue with multiple requests
      // for now, doing a hard refresh
      // this.router.navigate(['/'], { replaceUrl: true });
      window.location.replace('/');
    });
  }

  toggleNested() {
    this.nestedOpen.set(!this.nestedOpen());
  }

  generateLightColor(email: string) {
    let hash = 0;
    for (let i = 0; i < email.length; i++) {
      hash = email.charCodeAt(i) + ((hash << 5) - hash);
    }

    const hue = Math.abs(hash) % 360; // Hue: 0-360
    const saturation = 70;           // Saturation: 70%
    const lightness = 80;            // Lightness: 80%

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  }
}
